import React, { PureComponent, createElement, Fragment } from 'react';
import { Dropdown, Menu, Button, Icon, Modal, Form, Input, Radio } from 'antd';
import { ComponentsManager } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
import { UploadButton } from '../upload-button';
import { FormComponentProps } from 'antd/es/form';
import './index.less';

export interface ProductGoodsViewProps {
    click: () => void;
    form: FormComponentProps['form'];
    entity: Entity;
    params: any;
    componentId: string;
    selectedRowKeys: string[];
}

// 商品经营管理
class ProductGoodsInfoView extends PureComponent<ProductGoodsViewProps, any> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    renderTable() {
        const { entity, componentId } = this.props;
        const tableProps = {
            entity,
            componentId: componentId + '-Table',
            component: 'DataTable',
            switchRefresh: true,
            loadFirstPage: true,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: { x: true },
            columns: [
                {
                    property: 'id',
                },
                {
                    property: 'sku',
                },
                {
                    property: 'spu',
                },
                {
                    property: 'pzgPic',
                    width: 100,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'middlePic',
                    width: 100,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'name',
                },
                {
                    property: 'brand',
                    width: 120,
                },
                {
                    property: 'styleCode',
                },
                {
                    property: 'price',
                },
                {
                    property: 'type',
                    width: 100,
                },
            ],
            actionColumn: {
                title: '操作',
                width: 100,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'link',
                        text: '编辑',
                        path: '/product/info/{{row.id}}',
                    },
                ],
            },
        };
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    downloadMould(url: string) {
        services.api.download({}, { apiPath: url }).catch((e: any) => errorHandle(e));
    }

    render() {
        // 按照SKU管理
        const skuMenu = (
            <Menu>
                <Menu.Item key="1">
                    <UploadButton
                        accept=".zip"
                        action="/templates/UPDATE_IMAGE"
                        buttons={{ text: '批量导入图片', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={130}
                    />
                </Menu.Item>
                <Menu.Item key="2">
                    <UploadButton
                        accept=".xls,.xlsx,.csv"
                        action="/products/delPzgPic"
                        buttons={{ text: '批量删除图片', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={130}
                    />
                </Menu.Item>
                <Menu.Item key="3">
                    <Button
                        type="link"
                        onClick={() => {
                            this.downloadMould('/templates/DELETE_PRODUCT_PICTURES');
                        }}
                    >
                        下载删除图片模板
                    </Button>
                </Menu.Item>
            </Menu>
        );

        // 按照华夏款号管理
        const styleMenu = (
            <Menu>
                <Menu.Item key="1">
                    <UploadButton
                        accept=".zip"
                        action="/templates/UPDATE_IMAGE_STYLE_CODE"
                        buttons={{ text: '批量导入图片', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={130}
                    />
                </Menu.Item>
                <Menu.Item key="2">
                    <UploadButton
                        accept=".xls,.xlsx,.csv"
                        action="/products/delPzgPicByStyleCode"
                        buttons={{ text: '批量删除图片', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={130}
                    />
                </Menu.Item>
                <Menu.Item key="3">
                    <Button
                        type="link"
                        onClick={() => {
                            this.downloadMould('/templates/DELETE_PRODUCT_PICTURES_STYLE_CODE');
                        }}
                    >
                        下载删除图片模板
                    </Button>
                </Menu.Item>
            </Menu>
        );

        // 展示名称
        const presaleMenu = (
            <Menu>
                <Menu.Item key="1">
                    <UploadButton
                        accept=".xls,.xlsx,.csv"
                        action="/templates/UPDATE_SHOW_NAME"
                        buttons={{ text: '批量导入修改名称', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={130}
                    />
                </Menu.Item>
                <Menu.Item key="3">
                    <Button
                        type="link"
                        onClick={() => {
                            this.downloadMould('/templates/UPDATE_SHOW_NAME');
                        }}
                    >
                        下载模版
                    </Button>
                </Menu.Item>
            </Menu>
        );

        return (
            <>
                <Fragment>
                    <div className="optionBox">
                        <Dropdown overlay={skuMenu}>
                            <Button type="primary">
                                按SKU管理图片 <Icon type="down" />
                            </Button>
                        </Dropdown>
                        <Dropdown overlay={styleMenu}>
                            <Button type="primary">
                                按华夏款号管理图片 <Icon type="down" />
                            </Button>
                        </Dropdown>
                        <Dropdown overlay={presaleMenu}>
                            <Button type="primary">
                                修改展示名称 <Icon type="down" />
                            </Button>
                        </Dropdown>
                    </div>
                    {this.renderTable()}
                </Fragment>
            </>
        );
    }
}

export const ProductGoodsInfo = Form.create()(ProductGoodsInfoView);
